export default {"src":"/_next/static/media/roth-ira.472a6366.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};